<template>
  <div v-if="CaseShow" id="EditCase2" style="padding: 0 1em">
    <div class="course_title">編輯申請</div>

    <div class="table-responsive-sm">
      <table class="table" style="width: auto; align: left">
        <tbody>
          <tr>
            <td colspan="4" align="left">
              <span style="color: #f00"
                ><span style="color: #f00">＊</span>為必填項目。</span
              >
            </td>
          </tr>

          <tr align="left">
            <td colspan="4">
              申請本助學金，家庭年所得不能超過70萬，計算標準比照大專校院弱勢學生入學計畫：<br />
              1、未婚者：未成年與其父母或法定監護人合計；已成年與其父母或未成年時之法定監護人合計。<br />
              2、已婚者：與其配偶合計。<br />
              3、離婚或配偶死亡者：為同學本人之所得總額。<br />
              4、其他特殊條件：因父母離婚、遺棄或其他特殊因素，與父母或法定監護人合計顯失公平者，<br />
              得敘明理由，並检具相關文件資料（如近３個月內之詳細記事戶籍謄本或其他文件），經學校審查認定後，<br />
              該父母或法定監護人免予合計。
            </td>
          </tr>
          <tr align="left">
            <td>申請日期</td>
            <td>{{ getToday() }}</td>
            <td>申請學年/學期</td>
            <td>{{ queryInfo.schyy }}/{{ queryInfo.smt }}</td>
          </tr>
          <tr align="left">
            <td>編號</td>
            <td>關係人姓名</td>
            <td>與學生關係</td>
            <td>身分證字號</td>
          </tr>

          <tr align="left">
            <td>1</td>
            <td>
              <input
                type="text"
                class="form-control"
                v-model="queryInfo.relatedName1"
                placeholder="輸入姓名"
              />
            </td>

            <td>
              <div>
                <b-form-select
                  v-model="queryInfo.relatedStudent1"
                  :options="options1"
                ></b-form-select>
              </div>
            </td>
            <td>
              <input
                type="text"
                class="form-control"
                v-model="queryInfo.relatedId1"
                pattern="/^[A-Z]\d{9}$/"
                onKeyPress="if(this.value.length==10) return false;"
                placeholder="輸入身分證字號"
                required
              />
            </td>
          </tr>
          <tr align="left">
            <td>2</td>
            <td>
              <input
                type="text"
                class="form-control"
                v-model="queryInfo.relatedName2"
                placeholder="輸入姓名"
                required
              />
            </td>

            <td>
              <div>
                <b-form-select
                  v-model="queryInfo.relatedStudent2"
                  :options="options2"
                ></b-form-select>
              </div>
            </td>
            <td>
              <input
                type="text"
                class="form-control"
                v-model="queryInfo.relatedId2"
                pattern="/^[A-Z]\d{9}$/"
                onKeyPress="if(this.value.length==10) return false;"
                placeholder="輸入身分證字號"
                required
              />
            </td>
          </tr>
          <tr align="left">
            <td>3</td>
            <td>
              <input
                type="text"
                class="form-control"
                v-model="queryInfo.relatedName3"
                placeholder="輸入姓名"
                required
              />
            </td>

            <td>
              <div>
                <b-form-select
                  v-model="queryInfo.relatedStudent3"
                  :options="options3"
                ></b-form-select>
              </div>
            </td>
            <td>
              <input
                type="text"
                class="form-control"
                v-model="queryInfo.relatedId3"
                pattern="/^[A-Z]\d{9}$/"
                onKeyPress="if(this.value.length==10) return false;"
                placeholder="輸入身分證字號"
                required
              />
            </td>
          </tr>

          <tr align="left" v-if="queryInfo.file != undefined">
            <td><span style="color: #f00">＊</span>戶籍謄本</td>

            <td>
              <b-form-file
                class="mb-2"
                ref="file-input"
                :no-drop="true"
                :no-traverse="true"
                v-model="queryInfo.file"
                @input="fileChange(0)"
                placeholder="上傳戶籍謄本"
                accept="image/jpeg, image/png, image/gif, application/pdf"
                browse-text="選擇檔案"
              ></b-form-file>
              <span v-if="queryInfo.file.RowId != undefined">
                <a
                  :href="
                    './WebApi/Common/GetDocumentFile/' + queryInfo.file.RowId
                  "
                  target="_blank"
                >
                  <img src="@/assets/images/disk.png" />
                </a>
                {{
                  queryInfo.file.RowId != undefined ? queryInfo.file.name : ""
                }}
              </span>
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left">
            <td>本人同意</td>

            <td>
              送出申請的文字：
              本人確認有中華民國戶籍，就讀本校【產學攜手合作計畫】專班，具有學籍且修業年限內之學生。<br />
              同意教育部函請財政部資訊中心查調家庭年所得，若申請後有不符資格者，<br />
              願無條件將已獲學校補助之助學金款項繳回，絕無異議。特此聲明。
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr style="text-align: center">
            <td>
              <button
                class="btn active bg-info text-white rounded"
                @click="editCase()"
              >
                送出資料
              </button>
            </td>
            <td>
              <b-button @click="hideModal()"
                ><b-icon icon="x" />&nbsp;{{
                  $t("message.Close_cmd")
                }}
                </b-button
              >
            </td>
            <td>
              <b-button
                style="width: 6.5rem"
                type="reset"
                @click="onReset"
                variant="danger"
                >Reset</b-button
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>


<script>
import * as tools from "../tool";

export default {
  name: "EditCase2",
  props: ["id"],
  data() {
    return {
      CaseShow: false,
      relatedStudent1: null,
      options1: [
        { value: null, text: "請選擇" },
        { value: 1, text: "父親" },
        { value: 2, text: "母親" },
        { value: 3, text: "配偶" },
        { value: 5, text: "法定代理人" },
      ],
      relatedStudent2: null,
      options2: [
        { value: null, text: "請選擇" },
        { value: 1, text: "父親" },
        { value: 2, text: "母親" },
        { value: 3, text: "配偶" },
        { value: 5, text: "法定代理人" },
      ],
      relatedStudent3: null,
      options3: [
        { value: null, text: "請選擇" },
        { value: 1, text: "父親" },
        { value: 2, text: "母親" },
        { value: 3, text: "配偶" },
        { value: 5, text: "法定代理人" },
      ],
      relatedName1: null,
      relatedName2: null,
      relatedName3: null,
      relatedId1: null,
      relatedId2: null,
      relatedId3: null,
      memberShow: this.$store.state.user2,
      inputData: this.$store.state.inputData,
      inputData2: null,
      mode: false,
      file: [{ name: "", RowId: "" }],
      total: 0,
      isIE: false,
      selectedRowIndex: 0,
      currentPage: 1,
      pageSize: 10,
      queryInfo: {
        DataMode: 0,
        id: "",
        stdID: "",
        Info1: [],
        file: [],
        sid: "",
        relatedName1: null,
        relatedName2: null,
        relatedName3: null,
        relatedId1: null,
        relatedId2: null,
        relatedId3: null,
        relatedStudent1: 0,
        relatedStudent2: 0,
        relatedStudent3: 0,
        schyy: null,
        smt: null,
        UpdateUser: null,
        reason: null,
        rowId: "",
      },
    };
  },
  computed: {
    filteredDocs: function () {
      let data = [];
      if (this.inputData != null) {
        data = this.inputData.slice(
          (this.currentPage - 1) * this.pageSize,
          this.currentPage * this.pageSize
        );
      }
      return data;
    },
    headerColor() {
      return "#f7e8aa";
    },
  },
  methods: {
    hideModal() {
      this.$emit("hideModal");
    },

    onReset() {
      let vm = this;
      vm.queryInfo.relatedStudent1 = 0;
      vm.queryInfo.relatedStudent2 = 0;
      vm.queryInfo.relatedStudent3 = 0;
      vm.queryInfo.relatedName1 = "";
      vm.queryInfo.relatedName2 = "";
      vm.queryInfo.relatedName3 = "";
      vm.queryInfo.relatedId1 = "";
      vm.queryInfo.relatedId2 = "";
      vm.queryInfo.relatedId3 = "";
      vm.queryInfo.file[0] = [{ name: "", RowId: "" }];
    },
    CaseSelect(id) {
      this.$emit("CaseSelect", id);
    },

    isEmpty(data) {
      return data != "" && data != null && data != undefined ? false : true;
    },
    FileisEmpty(data) {
      var ret = false;
      if (data instanceof Blob || data instanceof File) {
        if (data.size > 0) {
          ret = true;
        }
      } else if (data.RowId != null) {
        ret = true;
      }
      return ret;
    },

    checkVal(str) {
      var regExp = /^[A-Z]\d{9}$/;
      if (regExp.test(str)) return true;
      else return false;
    },
    checkSaveData() {
      var msg = "";

      if (!this.isEmpty(this.queryInfo.relatedId1)) {
        var ret = tools.checkTWID(this.queryInfo.relatedId1);
        if (ret == false) {
          msg =
            this.queryInfo.relatedId1 +
            "身分證號碼格式不正確，請重寫關係人身分證1";
        }
        if (this.isEmpty(this.queryInfo.relatedName1)) {
          msg = "請輸入姓名";
        } else if (
          this.queryInfo.relatedStudent1 == 0 ||
          this.isEmpty(this.queryInfo.relatedStudent1)
        ) {
          msg = "請選擇與學生關係";
        }

        if (msg != "") return msg;
      }

      if (!this.isEmpty(this.queryInfo.relatedId2)) {
        var ret = tools.checkTWID(this.queryInfo.relatedId2);
        if (ret == false) {
          msg =
            this.queryInfo.relatedId2 +
            "身分證號碼格式不正確，請重寫關係人身分證2";
        }
        if (this.isEmpty(this.queryInfo.relatedName2)) {
          msg = "請輸入姓名";
        } else if (
          this.queryInfo.relatedStudent2 == 0 ||
          this.isEmpty(this.queryInfo.relatedStudent2)
        ) {
          msg = "請選擇與學生關係";
        }

        if (msg != "") return msg;
      }

      if (!this.isEmpty(this.queryInfo.relatedId3)) {
        var ret = tools.checkTWID(this.queryInfo.relatedId3);
        if (ret == false) {
          msg =
            this.queryInfo.relatedId3 +
            "身分證號碼格式不正確，請重寫關係人身分證3";
        }
        if (this.isEmpty(this.queryInfo.relatedName3)) {
          msg = "請輸入姓名";
        } else if (
          this.queryInfo.relatedStudent3 == 0 ||
          this.isEmpty(this.queryInfo.relatedStudent3)
        ) {
          msg = "請選擇與學生關係";
        }

        if (msg != "") return msg;
      }
      if (msg == "" && !this.FileisEmpty(this.queryInfo.file)) {
        msg = "請上傳金融帳戶封面影本";
      }
      return msg;
    },
    fileChange(index) {
      this.formData = new FormData();

      if (index == 0) {
        this.formData.append("header", this.queryInfo.file);
      }
      var vm = this;

      this.$http
        .post("./WebApi/Common/UploadV3", vm.formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: function (progressEvent) {
            console.log(
              "Upload progress: " +
                Math.round((progressEvent.loaded / progressEvent.total) * 100) +
                "%"
            );
          },
        })
        .then(function (response) {
          vm.queryInfo.Info1 = response.data;
          vm.queryInfo.DataMode = 1;
          console.log(response);
        })
        .catch(function (error) {
          console.log(error);
          console.log(error.response);
        });
    },
    getToday() {
      var dd = new Date();
      var today = dd.getDate().toString().padStart(2, "0"); //內建getDate 取到目前年月日
      var mm = (dd.getMonth() + 1).toString().padStart(2, "0"); //January is 0!
      var yyyy = dd.getFullYear();
      return tools.stringFormat("{0}/{1}/{2}", yyyy - 1911, mm, today);
    },
    editCase: function () {
      var msg = this.checkSaveData();
      if (msg.length != 0) {
        alert(msg);
        return null;
      }

      let vm = this;

      vm.$http
        .put("./WebApi/EconomicDisadvantage/EditCase/", vm.queryInfo)
        .then((response) => {
          if (0 < response.data) {
            alert("更新上傳成功");
            vm.CaseSelect(1);
          } else {
            alert("更新上傳失敗");
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, "danger", "對不起,網路連線失敗" + error);
        });
    },

    GetCurrentSchyy() {
      let vm = this;

      this.$http
        .get("./WebApi/EconomicDisadvantage/GetCurrentSchyy/")
        .then((response) => {
          if (response.data != null && response.data != 0) {
            vm.queryInfo.schyy = response.data.schyy;
            vm.queryInfo.smt = response.data.smt;
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, "danger", "對不起,網路連線失敗" + error);
        });
    },
    getCaseDetail() {
      let vm = this;

      vm.eid = vm._props.id;
      this.$http
        .get("../WebApi/EconomicDisadvantage/GetCaseDetail/".concat(vm.eid))
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.CaseShow = true;
            vm.inputData = response.data;
            vm.queryInfo.id = response.data[0].id;
            vm.queryInfo.sid = response.data[0].sid;
            vm.queryInfo.stdID = response.data[0].stdID;
            vm.queryInfo.schyy = response.data[0].schyy;
            vm.queryInfo.smt = response.data[0].smt;
            vm.queryInfo.UpdateUser = response.data[0].sid;
            vm.queryInfo.reason = "補件";
            vm.queryInfo.relatedName1 = response.data[0].relatedName1;
            vm.queryInfo.relatedName2 = response.data[0].relatedName2;
            vm.queryInfo.relatedName3 = response.data[0].relatedName3;
            vm.queryInfo.relatedId1 = response.data[0].relatedId1;
            vm.queryInfo.relatedId2 = response.data[0].relatedId2;
            vm.queryInfo.relatedId3 = response.data[0].relatedId3;
            vm.queryInfo.relatedStudent1 = response.data[0].relatedStudent1;
            vm.queryInfo.relatedStudent2 = response.data[0].relatedStudent2;
            vm.queryInfo.relatedStudent3 = response.data[0].relatedStudent3;

            if (response.data[0].attachInfoString != "null") {
              const jsonArr = JSON.parse(response.data[0].attachInfoString);
              vm.queryInfo.file.name = jsonArr.FileNm;
              vm.queryInfo.file.RowId = jsonArr.RowId;
              vm.queryInfo.rowId = jsonArr.RowId;
            }
          }
        })
        .catch(function (error) {
          alert("網路連線失敗" + error);
        });
    },
  },
  created() {
    console.log("======created EditCase2 =====");

    this.GetCurrentSchyy();
  },
  mounted() {
    console.log("======mounted EditCase2  =====");
    this.getCaseDetail();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
